import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  useNavigate,
  useLocation
} from "react-router-dom";

export default function MyTickets() {

  const [tickets, setTickets] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();

  const user =
    JSON.parse(localStorage.getItem("user")) || {};

  // READ URL QUERY
 
  // ?status=open
  // ?status=closed

  const queryParams =
    new URLSearchParams(location.search);

  const statusFilter =
    queryParams.get("status");

  useEffect(() => {

    if (!user.id) return;

    let url =
      `https://support.g6techcare.com/api/mytickets/${user.id}`;

    // ADD FILTER TO URL
    if (statusFilter) {
      url += `?status=${statusFilter}`;
    }

    axios
      .get(url)
      .then((res) => {
  console.table(
    res.data.map((item) => ({
      id: item.id,
      created_at: item.created_at,
    }))
  );

  setTickets(res.data);
})
      .catch((err) => {
        console.log(err);
      });

  }, [user.id, statusFilter]);

   const formatDate = (value) => {
  if (!value) return "";

  const raw = String(value).trim();

  const normalized = raw.includes("T")
    ? raw
    : raw.replace(" ", "T");

  const hasTimezone =
    /[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized);

  const parsedDate = new Date(
    hasTimezone
      ? normalized
      : `${normalized}Z`
  );

  if (Number.isNaN(parsedDate.getTime())) {
    return raw;
  }

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(parsedDate);
};

  const getStatusClass = (status) => {

    const s = (status || "").toLowerCase();

    if (s === "closed") {
      return "closed";
    }

    if (s.includes("progress")) {
      return "in_progress";
    }

    return "pending";
  };

  return (

    <div className="table-section">

      <h3>My Tickets</h3>

      <table>

        <thead>
          <tr>
            <th>ID</th>
            <th>Subject</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>

          {tickets.length > 0 ? (

            tickets.map((t) => (

              <tr
                key={t.id}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/ticket/${t.id}`)
                }
              >

                <td>#{t.id}</td>

                <td>{t.subject}</td>

                <td>{t.priority}</td>

                <td className={getStatusClass(t.status)}>
                  {t.status}
                </td>

                <td>
                  {formatDate(t.created_at)}
                </td>

              </tr>

            ))

          ) : (

            <tr>
              <td colSpan="5">
                No tickets found
              </td>
            </tr>

          )}

        </tbody>

      </table>

    </div>

  );
}